
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAbstractAutomationButtonMotorized as ObcAbstractAutomationButtonMotorizedElement} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/abstract-automation-button-motorized.js';
 
 
 

 
 export const ObcAbstractAutomationButtonMotorized = createComponent({
   react: React,
   tagName: 'undefined',
   elementClass: ObcAbstractAutomationButtonMotorizedElement,
   events: {
     
   }
  });
 
 